import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KycCustomerIdentifyRoutingModule } from './kyc-customer-identify-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { WebcamModule } from 'ngx-webcam';
import { MaterialModule } from 'src/app/core/material';
import { AlertEkycComponent } from 'src/app/shared/components/alert-ekyc/alert-ekyc.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { KycCustomerIdentifyComponent } from './kyc-customer-identify.component';
import { RefuseSuccessComponent } from './refuse-success/refuse-success.component';
import { OtpIdentifyComponent } from './otp-identify/otp-identify.component';
import { RefuseIdentifyComponent } from './refuse-identify/refuse-identify.component';


@NgModule({
  declarations: [KycCustomerIdentifyComponent, RefuseIdentifyComponent, OtpIdentifyComponent, RefuseSuccessComponent],
  imports: [
    CommonModule,
      KycCustomerIdentifyRoutingModule,
      TranslateModule,
      MaterialModule,
      SharedModule,
      NgxExtendedPdfViewerModule,
      FormsModule,
      ReactiveFormsModule,
      WebcamModule,
  ],
  entryComponents: [
    AlertEkycComponent,
    RefuseIdentifyComponent,
    OtpIdentifyComponent,
    RefuseSuccessComponent
  ],
})
export class KycCustomerIdentifyModule { }
